/**
 * RISK-FAMILIES
 * List of families
 */
import { useAppSelector } from "@/core/root-reducer"
import RiskFamilyCard from "./RiskFamilyCard"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import { RiskFamily } from "../model/risk-family.types"
import CardContainer from "@/components/card-container"
import { filterRiskFamiliesWithRisks } from "../model/risk-family.utils"
import type { RiskFamiliesDisplayMode } from "./RisksUserSettings"

interface Props {
  hideEmpty?: boolean
  onClickFamily?: (family: RiskFamily) => void
}

export default function RiskFamilies({ hideEmpty, onClickFamily }: Props) {
  const families = useAppSelector(physicalRiskStore.selectors.listFamilies)
  const risks = useAppSelector(physicalRiskStore.selectors.list)
  const userDisplayMode = useAppSelector((state) => state._session.userOptions.risksFamiliesDisplayMode)
  const displayMode: RiskFamiliesDisplayMode = userDisplayMode ?? "grid"
  const nonEmptyFamilies = hideEmpty ? filterRiskFamiliesWithRisks(families, risks) : families

  return (
    <CardContainer isAlignedLeft displayMode={displayMode}>
      {nonEmptyFamilies.map((family) => (
        <RiskFamilyCard
          key={family.id}
          family={family}
          displayMode={displayMode}
          onClick={onClickFamily ? () => onClickFamily(family) : undefined}
        />
      ))}
    </CardContainer>
  )
}
